const USER_LEVELS = {
  UNIVERSITY_HEAD_LEVEL: 1,
  COLLEGE_HEAD_LEVEL:1 ,
  PROFESSOR_LEVEL: 3,
};

const COURSE_OPTIONS = [
  { label: "B.Tech", value: "B.Tech" },
  { label: "M.Tech", value: "M.Tech" },
  { label: "Pharm.D", value: "Pharm.D" }, 
  { label: "M.Pharmacy", value: "M.Pharmacy" },
  { label: "MBA", value: "MBA" },
  { label: "MCA", value: "MCA" },
];

const REGULATION_OPTIONS = [
  { label: "R13", value: "R13" },
  { label: "R16", value: "R16" },
  { label: "R19", value: "R19" },
  { label: "R20", value: "R20" },
  { label: "R23", value: "R23" },
];
export { USER_LEVELS, COURSE_OPTIONS, REGULATION_OPTIONS };
